import { useContext } from "react";
import { DisableGroupContext } from "./DisableGroupContext";

/**
 * Returns whether the component should be disabled. The `DisabledGroup`'s `disabled` property only takes into effect if the component
 * does not explicitly have a disabled/enabled state set.
 * @param props The input base properties.
 * @returns Whether the input should be disabled.
 */
export function useDisabled(props: { disabled?: boolean }): boolean {
  const { disabled } = props;
  const { disabled: groupDisabled } = useContext(DisableGroupContext);

  if (disabled === undefined) return groupDisabled;

  return disabled;
}
